import React from "react"
import { isEmpty } from "lodash"
import Button from "components/common/Button"
import FormMobile from "components/form/mobile"
import FormInput from "components/form/input"
import FormDatePicker from "components/form/datepicker"
import FormDropDown from "components/form/dropdown"
import Text from "components/text"
import Panel from "components/panel"
import "styles/pages/personal-details.scss"
import "react-datepicker/dist/react-datepicker.css"
import CheckBox from "components/checkbox"
class PersonalDetailsForm extends React.Component {
  selectRefs = {
    gender: React.createRef(),
    type: React.createRef(),
    suffix: React.createRef(),
  }

  componentDidUpdate(prevProps) {
    const { error: prevError } = prevProps
    const { error } = this.props

    if (!isEmpty(error) && prevError !== error) {
      for (let fieldName in error) {
        if (this.selectRefs[fieldName]) {
          let field = this.selectRefs[fieldName]
          field.current.focus()
        } else {
          let field = document.getElementsByName(fieldName)
          if (field.length > 0) {
            field[0].focus()
          }
        }
        break
      }
    }
  }

  render() {
    const {
      userInfo: {
        first_name,
        middle_name,
        last_name,
        suffix,
        mobile_number,
        birthday,
        school,
        course,
        country_code,
        gender,
        type,
        license_number,
      },
      handleChange,
      handleChangeDate,
      handleSave,
      loading,
      error = {},
      handleChangeCountry,
      countryCode,
      handleSelect,
      role,
      schoolConfig,
      isLicenseNA,
      toggleLicenseNotApplicable,
    } = this.props

    let defaultValue = countryCode.find(
      (code) => code.country_code === country_code
    )
    const occupationList = [
      { key: "student", value: "S", label: "Student" },
      { key: "professional", value: "P", label: "Professional" },
      { key: "others", value: "O", label: "Others" },
    ]
    const genderList = [
      { key: "male", value: "M", label: "Male" },
      { key: "female", value: "F", label: "Female" },
    ]
    const suffixList = [
      { key: "jr", value: "Jr.", label: "Jr." },
      { key: "sr", value: "Sr.", label: "Sr." },
      { key: "i", value: "I", label: "I" },
      { key: "ii", value: "II", label: "II" },
      { key: "iii", value: "III", label: "III" },
      { key: "iv", value: "IV", label: "IV" },
      { key: "v", value: "V", label: "V" },
    ]

    const isStudent = role === "ST"
    const isMCLESchool = schoolConfig?.products?.mcle
    const isCPALicenseEnabled = schoolConfig?.products?.cpa_cpd
    return (
      <>
        <Panel pad="24">
          <div className="note-container">
            <span className="icon-success">
              <i className="fas fa-exclamation-circle fa-3x"></i>
            </span>
            <p>
              {`Please provide your full name — including your full middle name,
              suffixes, etc. — as it appears on your valid government ID. This
              name will be used for your Certificates${
                isMCLESchool ? " and for the MCLE Report." : "."
              } `}
            </p>
          </div>
        </Panel>
        <div className="personal-details">
          <Panel pad="40" grid>
            <Text type="headline" text="Basic Information" />
            <FormInput
              label={"First Name"}
              name={"first_name"}
              value={first_name}
              handleChange={handleChange}
              error={error.first_name}
              required={true}
            />
            <FormInput
              label={"Middle Name"}
              name={"middle_name"}
              value={middle_name}
              handleChange={handleChange}
              error={error.middle_name}
              labelFor={
                "For those without a middle name, kindly put a space in the data field."
              }
              required={true}
            />
            <FormInput
              label={"Last Name"}
              name={"last_name"}
              value={last_name}
              handleChange={handleChange}
              error={error.last_name}
              required={true}
            />
            <FormDropDown
              label={"Suffix"}
              name={"suffix"}
              value={suffix}
              options={suffixList}
              handleChange={handleSelect}
              fieldRef={this.selectRefs.suffix}
              isClearable
            />
            <FormMobile
              name={"mobile_number"}
              label={"Mobile Number"}
              value={mobile_number}
              handleChange={handleChange}
              error={error.mobile_number}
              options={countryCode}
              country_code={defaultValue}
              handleChangeCountry={handleChangeCountry}
              required={true}
            />
            {isStudent && (
              <>
                <FormDatePicker
                  name={"birthday"}
                  label={"Birthdate"}
                  value={birthday ? birthday : null}
                  handleChangeDate={handleChangeDate}
                  error={error.birthday}
                  required={true}
                />
                <FormDropDown
                  label={"Gender"}
                  name={"gender"}
                  value={gender}
                  options={genderList}
                  handleChange={handleSelect}
                  error={error.gender}
                  required={true}
                  fieldRef={this.selectRefs.gender}
                />
              </>
            )}
            {isStudent && (
              <>
                <FormDropDown
                  label={"Occupation"}
                  name={"type"}
                  value={type}
                  options={occupationList}
                  handleChange={handleSelect}
                  error={error.type}
                  required={true}
                  fieldRef={this.selectRefs.type}
                />
              </>
            )}
            {type !== "O" && isStudent && (
              <>
                <FormInput
                  type={"text"}
                  label={type === "S" ? "School" : "Company"}
                  name={"school"}
                  value={school}
                  handleChange={handleChange}
                  error={error.school}
                />
                <FormInput
                  type={"text"}
                  label={type === "S" ? "Course" : "Position"}
                  name={"course"}
                  value={course}
                  handleChange={handleChange}
                  error={error.course}
                />
              </>
            )}
            {isCPALicenseEnabled && (
              <>
                <FormInput
                  type="number"
                  label="CPA License No."
                  name="license_number"
                  value={isLicenseNA ? "" : license_number}
                  error={error.license_number}
                  handleChange={handleChange}
                  disabled={isLicenseNA}
                />
                <CheckBox
                  text="Not applicable"
                  value={isLicenseNA}
                  checked={isLicenseNA}
                  onChange={toggleLicenseNotApplicable}
                  id="chk-license-na"
                />
              </>
            )}
            <div className="actions">
              <Button
                label="Save Information"
                size="large"
                onClick={handleSave}
                loading={loading}
              />
            </div>
          </Panel>
        </div>
      </>
    )
  }
}

export default PersonalDetailsForm
